import React, { useContext } from "react";
import "./style/Login.css";
import { UserContext } from "../components/context/Context";
import { auth, provider } from "../Firebase";
import logo from "../imgs/book-logo.svg";

function Login() {
  const [user, setUser] = useContext(UserContext);
  const signIn = () => {
    auth
      .signInWithPopup(provider)
      .then((res) => setUser(res))
      .catch((err) => alert(err.message));
  };
  return (
    <div className="login">
      <img src={logo} alt="logo" />
      <button onClick={signIn}>sign In with google</button>
    </div>
  );
}

export default Login;
